import { Dashboard } from "../../components/dashboard/Dashboard";
import { MessageList } from "./MessageList";

export const MessagesDashboard = () => {
  return (
    <Dashboard
      width={1024}
      parentComponent={<MessageList />}
      parentPart={"minmax(400px,36%)"}
      childPart={"1fr"}
    />
  );
};
